// material-ui
import { Theme } from '@mui/material/styles';

// ==============================|| OVERRIDES - TAB ||============================== //

export default function Tab(theme: Theme) {
  return {
    MuiTab: {
      styleOverrides: {
        root: {
          minHeight: 46,
          color: theme.palette.text.primary,
          borderRadius: 4,
          '&:hover': {
            backgroundColor: 'var(--nv-bg-hover)',
            color: 'var(--nv-text-primary)'
          },
          // V10: the active tab is marked by weight + the yellow indicator, never yellow text
          '&.Mui-selected': {
            color: 'var(--nv-text-primary)',
            fontWeight: 600
          },
          '&:focus-visible': {
            borderRadius: 4,
            outline: '2px solid var(--nv-focus-ring)',
            outlineOffset: -3
          }
        }
      }
    }
  };
}
